export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      user: false,
      superAdmin: true,
      admin: true
    },
    {
      name: 'Ads',
      url: '/ads/list',
      icon: 'fa fa-dollar',
      user: false,
      superAdmin: true,
      admin: true
    },
    {
      name: 'Surveys',
      url: '/surveys/list',
      icon: 'fa fa-list-ol',
      user: false,
      superAdmin: true,
      admin: true
    },
    {
      name: 'Reporting',
      url: '/reporting',
      icon: 'fa fa-table',
      user: false,
      superAdmin: true,
      admin: true,
      children: [
        {
          name: 'Branch Report',
          url: '/reporting/branch-report',
          icon: 'fa fa-table',
          user: false,
          superAdmin: true,
          admin: true
        },
        {
          name: 'Region Report',
          url: '/reporting/region-report',
          icon: 'fa fa-table',
          user: false,
          superAdmin: true,
          admin: true
        },
        {
          name: 'User Report',
          url: '/reporting/user-report',
          icon: 'fa fa-table',
          user: false,
          superAdmin: true,
          admin: true
        },
        {
          name: 'Survey Report',
          url: '/reporting/survey-report',
          icon: 'fa fa-table',
          user: false,
          superAdmin: true,
          admin: true
        },
        {
          name: 'Ad Report',
          url: '/reporting/ad-report',
          icon: 'fa fa-table',
          user: false,
          superAdmin: true,
          admin: true
        },
        {
          name: 'Charts',
          url: '/reporting/charts',
          icon: 'fa fa-pie-chart',
          user: false,
          superAdmin: true,
          admin: true
        }
      ]
    },
    {
      name: 'Admin',
      url: '/admin',
      icon: 'icon-settings',
      user: false,
      superAdmin: true,
      admin: true,
      children: [
        {
          name: 'Users',
          url: '/admin/users',
          icon: 'icon-user',
          user: false,
          superAdmin: true,
          admin: true
        },
        {
          name: 'Companies',
          url: '/admin/companies',
          icon: 'icon-globe',
          user: false,
          superAdmin: true,
          admin: false
        },
        {
          name: 'Regions',
          url: '/admin/regions',
          icon: 'icon-location-pin',
          user: false,
          superAdmin: true,
          admin: true
        },
        {
          name: 'Branches',
          url: '/admin/branches',
          icon: 'icon-home',
          user: false,
          superAdmin: true,
          admin: true
        },
        {
          name: 'Devices',
          url: '/admin/devices',
          icon: 'fa fa-server',
          user: false,
          superAdmin: true,
          admin: true
        }
      ]
    }
  ]
}
